angular.module('iw.frontyard.signup')
    .directive('iwDisableInput', function() {
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                disablePattern: '@disablePattern',
                keyDown: '@keyDown'
            },
            link: function(scope, element, attr, ngModelCtrl) {
                var pattern = new RegExp(scope.disablePattern),
                    keyDown = parseInt(scope.keyDown);
                element.bind('keydown', function(e) {
                    if (e.which === keyDown) {
                        return false;
                    }
                });
                element.bind('paste', function(e) {
                    function fromUser(text) {
                        if (!text) return text;
                        var transformedInput = text.replace(pattern, '');
                        if (transformedInput !== text) {
                            ngModelCtrl.$setViewValue(transformedInput);
                            ngModelCtrl.$render();
                        }
                        return transformedInput;
                    }
                    ngModelCtrl.$parsers.push(fromUser);
                });
            }
        }
    });
